// extracted by mini-css-extract-plugin
export default {"root":"Preloader_root__CODV+","loader":"Preloader_loader__YPX4p","animationLoader":"Preloader_animationLoader__bEvzl"};